import {
	DateLabel, DefaultButton, StatusLabel, TableItem,
} from '@Atoms';
import { PaperContainer } from '@Molecules';
import { Visibility } from '@mui/icons-material';
import { Grid, useTheme } from '@mui/material';
import { DataTable, TableColumn } from '@Organisms';
import { IPagination, IArticle, IPaginationTable } from '@Types';
import { useTranslation } from 'react-i18next';
import React from 'react';

export interface ArticlesListPageProps {
   articles: IPagination<IArticle[]> | undefined;
   onPageChange: (pagination: IPaginationTable) => void;
   onSearch: (query: string) => void;
   handleListAction: (action: string, item?: IArticle) => void
}

const ArticlesListPage = (props: ArticlesListPageProps) => {
	const {
		articles, onPageChange, onSearch, handleListAction,
	} = props;
	const { t } = useTranslation('translations');
	const theme = useTheme();

	return (
		<div>
			<Grid sx={{ padding: theme.spacing(3) }} container spacing={3}>
				<Grid item xs={12} md={12}>
					<DefaultButton title={t('new')} onClick={() => handleListAction(t('new'))} />
				</Grid>
				<Grid item xs={12} md={12}>
					<PaperContainer>
						<DataTable
							data={articles?.data || []}
							onSearching={(query) => onSearch(query)}
							onChange={(page, size) => onPageChange({ page, size })}
							pagination
							total={articles?.total}
						>
							<TableColumn headerText="ID" render={(item) => `${item.id}`} />
							<TableColumn headerText={t('registration')} render={(item) => <DateLabel date={item.registration} showTime />} />
							<TableColumn headerText={t('title')} render={(item) => `${item.title}`} />
							<TableColumn headerText={t('language')} render={(item) => <TableItem title={item.language.name} />} />
							<TableColumn
								headerText={t('banner')}
								render={(item) => (
									<DefaultButton
										startIcon={<Visibility />}
										title={t('view')}
										variant="outlined"
										onClick={() => handleListAction(t('view'), item)}
									/>
								)}
							/>
							<TableColumn
								headerText={t('link')}
								render={(item) => (
									item?.link && (
										<DefaultButton
											title={t('access')}
											variant="outlined"
											onClick={() => handleListAction(t('access'), item)}
										/>
									)
								)}
							/>
							<TableColumn
								headerText={t('status')}
								render={(item) => <StatusLabel status={item.status} />}
							/>
							<TableColumn
								headerText={t('details')}
								render={(item) => (
									<DefaultButton
										title={t('details')}
										variant="contained"
										onClick={() => handleListAction(t('details'), item)}
									/>
								)}
							/>
						</DataTable>
					</PaperContainer>
				</Grid>
				<Grid item xs={12} md={12} />
			</Grid>
		</div>
	);
};

export default ArticlesListPage;
